//Import
import React, { useEffect, useReducer, useState } from "react";

//Layouts
import GroupHeader from "../../components/GroupHeader";
import GroupTableContainer from "../../components/GroupTableContainer";
import GroupItemVer from "../../components/GroupItemVer";
import GroupTableHeader from "../../components/GroupTableHeader";
import NavBar from "../../components/NavBar";

//vars
import ofc from "../../settings/variables";
import {  URL_BASE_API_V3} from "../../settings/urlBaseApi";
import {
  verAbonosInitialState,
  verAbonosReducer,
} from "../../reducers/verAbonosReducer";
import { helpHttp } from "../../helpers/helpHtpp";
import Loader from "../../components/Loader/Loader";
import Mensaje from "../../components/Mensaje/Mensaje";
import { types } from "../../types/types";
import { Modal as ModalAnt } from "antd";

import { message } from "antd";
import { formatNumber } from "../../helpers/formatNumber";
import ModalVerAbonos from "../../components/ModalVerAbonos/ModalVerAbonos";
import {formatDateShort} from "../../helpers/formatDate";

// Componente base
const VerAbonosView = ({ ...props }) => {
  const [state, dispatch] = useReducer(verAbonosReducer, verAbonosInitialState);
  const { db, totalAbonos } = state;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
  const [dataModalDetalle, setDataModalDetalle] = useState("");
  const [dataModalDetalleAbonos, setDataModalDetalleAbonos] = useState("");
  const [dataModalDetalleCuotas, setDataModalDetalleCuotas] = useState("");

  // IDs de forma de pago que requieren detalle de cuotas (diario y semanal)
  const FORMA_PAGO_DIARIO_ID = 1;
  const FORMA_PAGO_SEMANAL_ID = 2;

  const closeModalDetalle = () => {
    setModalDetalleVisible(false);
  };

  const handleClickDetalle = (el) => {
    const esDiarioOSemanal =
        el.credito?.forma_pago?.id === FORMA_PAGO_DIARIO_ID ||
        el.credito?.forma_pago?.id === FORMA_PAGO_SEMANAL_ID;

    cargarAbonosCredito(el.credito_id);
    cargarCuotasCredito(el.credito_id, esDiarioOSemanal);
    setDataModalDetalle(el);
    setModalDetalleVisible(true);
  };

  const cargarAbonosCredito = (creditoId) => {
    let urlAbonosCreditos =
        URL_BASE_API_V3 + "/creditos/" + creditoId + "/abonos";
    setLoading(true);

    helpHttp()
        .get(urlAbonosCreditos)
        .then((res) => {
          if (res !== undefined) {
            if (!res.err) {
              setError(null);
              setDataModalDetalleAbonos(res);
            } else {
              setError(res);
            }
          }
        });

    setLoading(false);
  };

  // Solo consulta el endpoint de cuotas cuando el crédito tiene
  // forma de pago diaria o semanal (ver handleClickDetalle)
  const cargarCuotasCredito = (creditoId, debeCargarCuotas) => {
    if (!debeCargarCuotas) {
      setDataModalDetalleCuotas("");
      return;
    }

    let urlCuotasCredito =
        URL_BASE_API_V3 + "/creditos/" + creditoId + "/cuotas";

    helpHttp()
        .get(urlCuotasCredito)
        .then((res) => {
          if (res !== undefined && !res.err) {
            setDataModalDetalleCuotas(res);
          }
        });
  };

  const filtroBusqueda = ({ target }) => {
    dispatch({
      type: types.ver_abonos_buscar,
      payload: target.value,
    });
  };

  const limpiarFiltroBusqueda = () => {
    dispatch({
      type: types.ver_abonos_limpiar_filtro,
    });
  };

  const handleClickEliminar = (e, el) => {
    e.preventDefault();
    ModalAnt.confirm({
      title: `Eliminar abono`,
      content: `¿Está seguro de eliminar el abono del cliente ${
        el.credito.cliente.nombre_completo
      } por valor de ${formatNumber(el.monto_total)}`,
      cancelText: "Cancelar",
      okText: "Eliminar",
      onOk: () => eliminarAbono(el),
    });
  };

  const eliminarAbono = (el) => {
    let url = URL_BASE_API_V3 + "/abonos/" + el.id;
    setLoading(true);
    helpHttp()
      .del(url)
      .then((res) => {
        if (!res.err) {
          if (res instanceof TypeError) {
            message.error({
              content: `Abono del cliente ${
                el.credito.cliente.nombre_completo
              } por valor de ${formatNumber(
                el.monto_total
              )} no fue eliminado, intentelo de nuevo!`,
            });
          } else {
            setError(null);
            dispatch({
              type: types.ver_abonos_eliminar,
              payload: el,
            });
            message.success({
              content: `Abono del cliente ${
                el.credito.cliente.nombre_completo
              } por valor de ${formatNumber(el.monto_total)} fue eliminado!`,
            });
          }
        } else {
          message.error({
            content: `Hubo un error, el abono del cliente ${
              el.cliente.nombre_completo
            } por valor de ${formatNumber(el.monto_total)} no fue eliminado!`,
          });
        }
        setLoading(false);
      });
  };

  let url = URL_BASE_API_V3 + "/abonos/del-dia";
  useEffect(() => {
    setLoading(true);
    helpHttp()
      .get(url)
      .then((res) => {
        if (res !== undefined) {
          if (!res.err) {
            setError(null);
            dispatch({
              type: types.ver_abonos_todos,
              payload: res.abonos,
            });
          } else {
            setError(res);
          }
        }
        setLoading(false);
      });
  }, [url]);

  return (
    <div {...props}>
      <GroupHeader
        category="Ver Abonos"
        filtroBusqueda={filtroBusqueda}
        limpiarFiltroBusqueda={limpiarFiltroBusqueda}
      />
      <ModalVerAbonos
        show={modalDetalleVisible}
        opacity="0.8"
        w={"15em"}
        closeModalDetalle={closeModalDetalle}
        dataModalDetalle={dataModalDetalle}
        dataModalDetalleAbonos={dataModalDetalleAbonos}
        dataModalDetalleCuotas={dataModalDetalleCuotas}
      ></ModalVerAbonos>
      <GroupTableContainer>
        <GroupTableHeader section="Ver Abonos" />
        {db !== null ? (
          db.map((el) => {
            let diasMoraDefault = localStorage.getItem("diasMoraDefault");
            let colorIcono = ofc.primary;
            if (el.credito.monto_adelantado > 0 && el.credito.saldo_pendiente > 0) {
              colorIcono = ofc.violet;
            } else if (el.credito.dias_atraso >= diasMoraDefault) {
              colorIcono = ofc.yellow;
            }

            return (
              <GroupItemVer
                key={el.id}
                username={el.credito.cliente.nombre_completo}
                userdebt={formatNumber(el.saldo_pendiente)}
                uservalue={formatNumber(el.monto_total)}
                iconcolor={colorIcono}
                valuecolor="blue"
                fechaCreacionCredito={el.credito.created_at}
                fechaCuotaCredito={
                  <>
                  {formatDateShort(el.credito.proxima_cuota_vence)} - <strong>{el.credito.forma_pago.nombre}</strong>
                  </>
                }
                prestado={formatNumber(el.credito.monto_principal)}
                montoAdelantado={el.credito.monto_adelantado}
                montoVencido={el.credito.monto_vencido}
                saldoActualCredito={el.credito.saldo_pendiente}
                handleClickEliminar={(e) => handleClickEliminar(e, el)}
                textoEliminar="Abono"
                handleClickDetalle={(e) => handleClickDetalle(el)}
                mostrarSaldo={true}
              />
            );
          })
        ) : (
          <Mensaje
            mensaje="No hay información para mostrar"
            type="info"
            title="Información"
          />
        )}
        {error && (
          <Mensaje
            mensaje={`Error ${error.status}: ${error.statusText}`}
            type="error"
            title="Error"
          />
        )}
      </GroupTableContainer>
      {loading && <Loader />}
      <NavBar
        texto1="No. Abonos"
        texto2="Total Abonos"
        totalTexto1={
          db != null ? db.filter((abono) => abono.monto_total > 0).length : 0
        }
        totalTexto2={formatNumber(totalAbonos)}
        view="ver-abonos"
      />
    </div>
  );
};
export default VerAbonosView;
